import { takeEvery, select, call } from 'redux-saga/effects';
import * as apiCommon from '../../services/apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export function createLogMessage(options) {
  const { user, action } = options;

  return {
    doc_type: DocType.ACCESS_LOG,
    action,
    entity_id: user.id,
    application: 'admin',
    // subsidiary_id: user && user.subsidiary_details && user.subsidiary_details.subsidiary && user.subsidiary_details.subsidiary._id
  };
}

export function* logOnlineAuthSuccessSaga(app) {
  yield takeEvery('ACCESS_LOG_ONLINE_AUTH_SUCCESS', callLogOnlineAuthSuccessSaga, app);
}
function* callLogOnlineAuthSuccessSaga(app) {
  try {
    const { user } = yield select();
    const logMessage = createLogMessage({ app, user, action: 'login' });

    yield call(apiCommon.saveDoc, app, { doc: logMessage });
  } catch (error) {
    console.error('Log..', error.message);
  }
}
